import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'cmn-search',
    templateUrl: './search.component.html',
    styleUrls: [ './search.component.scss' ],
})

export class SearchComponent {
    @Input() public readonly label: string;
    @Input() public readonly hasButton: boolean;
    @Input() public readonly placeholder: string;
    @Input() public readonly iconLeft: { name: string, size: string };

    public text: string;

    @Output('onSearch') public readonly fireSearch: EventEmitter<string>;
    @Output('onChange') public readonly fireChange: EventEmitter<string>;
}
